import request from "@/utils/request";
export function regionList() {
    return request({
        url: "/resource/region_list",
        method: "GET"
    });
}
export function availableRegion(data) {
    return request({
        url: "/resource/is_region_sellable",
        method: "GET",
        params: data
    });
}
export function availableRegionV2(data) {
    return request({
        url: "/resource/is_region_sellable_v2",
        method: "GET",
        params: data
    });
}
